import React from "react";
import { Trans } from "react-i18next";

const otherFiltersOptions = [
  {
    text: <Trans i18nKey="discovery.filters.other.verified" />,
    value: "is_verified",
  },
  {
    text: <Trans i18nKey="discovery.filters.other.credible" />,
    value: "onlyCredibleAccount",
  },
  {
    text: <Trans i18nKey="discovery.filters.other.private" />,
    value: "is_hidden",
  },
  {
    text: <Trans i18nKey="discovery.filters.other.audience" />,
    value: "has_audience_data",
  },
  {
    text: <Trans i18nKey="discovery.filters.other.contact" />,
    value: "hasContactDetails",
  },
  {
    text: <Trans i18nKey="discovery.filters.other.sponsored" />,
    value: "hasSponseredPosts",
  },
];

export default otherFiltersOptions;
